import { useFlags } from 'launchdarkly-react-client-sdk';

// Redesign of the PBB signup page. Also gates FINTECH-5263 dispensary-context (cname)
// preservation on /pay/signup entry points: when off, useOpenDutchiePay and the in-store /
// churn-cancel signup pushes fall back to their legacy cname-less behavior.
export const PBB_SIGNUP_REDESIGN_FLAG = 'fintech.platform.pbb-signup-redesign.rollout';

export function usePbbSignupRedesignEnabled(): boolean {
  const flags = useFlags();
  return flags[PBB_SIGNUP_REDESIGN_FLAG] ?? false;
}

// Kill-switch for the order-confirmation Pay-by-Bank payment-switch feature.
// When off, the V2 confirmation modal, the CTA, the post-enrollment hand-off,
// the cart-approval write path, and the modal-reopen effect all become no-ops.
export const PBB_PAYMENT_SWITCH_FLAG = 'ecomm.order-confirmation.pbb-payment-switch.rollout';

// Kill-switch for the one-click (no-redirect) Pay-by-Bank approval flow inside the confirmation
// modal, independent of PBB_PAYMENT_SWITCH_FLAG. While off, the modal keeps redirecting to
// /pay/instore; once on-click one-click cart-token acquisition + approval are validated for a
// dispensary, this flag can be flipped without touching the redirect fallback.
export const PBB_ONE_CLICK_FLAG = 'ecomm.order-confirmation.pbb-one-click.rollout';

// Independent kill-switch for persisting a PBB checkout decline and suppressing the matching
// order-confirmation CTA. This intentionally does not reuse the payment-switch rollout flag.
export const PBB_DECLINE_CTA_SUPPRESSION_FLAG = 'ecomm.order-confirmation.pbb-decline-cta-suppression.rollout';
